module.exports = __webpack_public_path__ + "img/login-v2-dark.1c2a6da2.svg";